module.exports = __webpack_public_path__ + "static/img/2_1_1.a76f2e16.jpg";